/* eslint-disable no-use-before-define */
import store from "state/store";

export const ALLOW = "allow";
export const DENY = "deny";
export const NO_DECISION = "no_decision";

// type Role = string; // e.g. admin, ambassador, etc
// type Roles = { [role: Role]: boolean }; // e.g. {admin: true}

// type Decision = ALLOW | DENY | NO_DECISION;
// type Rule = () => Decision;
// type AllowRule = () => ALLOW | NO_DECISION;
// type DenyRule = () =>  DENY | NO_DECISION;
// type Policy = Rule[];

// Explanation:

// `Rule` is a function that returns `Decision` when evaluated.
// Typically, `Rule` is either `AllowRule` (returns ALLOW or NO_DECISION) or `DenyRule` (returns DENY or NO_DECISION).

// `Policy` (aka Access `Rule`s) is a list of `Rule`s that are evaluated in order.
// Therefore, `DenyRule`s should always be set first, followed by `AllowRule`s.
// If a `Rule` returns ALLOW or DENY, the evaluation stops and that `Decision` is returned.
// If the last `Rule` evaluates to NO_DECISION, the policy evaluation will return the default Decision (which in our case is DENY).

/**
 * AllowRule - allow if user has a specified role
 */
export const allowRole = (role) => {
  return () => {
    return hasRole(role) ? ALLOW : NO_DECISION;
  };
};

/**
 * DenyRule - deny if user has a specified role
 */
export const denyRole = (role) => {
  return () => {
    return hasRole(role) ? DENY : NO_DECISION;
  };
};

/**
 * AllowRule - allow all users access
 */
export const allowAll = () => {
  return () => {
    return ALLOW;
  };
};

/**
 * AllowRule - allow all logged-in users access
 */
export const allowLoggedIn = () => {
  return () => {
    return hasJWT() ? ALLOW : NO_DECISION;
  };
};

/**
 * AllowRule - allow if user is TomoCredit employee
 */
export const allowTomoCreditEmail = () => {
  return () => {
    try {
      const state = store.getState();
      const email = state.user.id;
      if (email?.split("@")[1] === "tomocredit.com") {
        return ALLOW;
      }
    } catch (err) {
      console.error(err);
    }
    return NO_DECISION;
  };
};

/**
 * DenyRule - deny if accessed from a certain domain
 */
export const denyDomain = (domain) => {
  return () => {
    if (domain === window.location.hostname) {
      return DENY;
    }
    return NO_DECISION;
  };
};

const hasRole = (role) => {
  const state = store.getState();
  const userRoles = state.user.roles || {};
  return !!userRoles[role];
};

const evaluteRules = (rules) => {
  // eslint-disable-next-line no-restricted-syntax
  for (const rule of rules || []) {
    const decision = rule();
    if (decision === DENY || decision === ALLOW) {
      return decision;
    }
  }
  return DENY;
};
const evalutePolicy = evaluteRules;

// Checks permission a/g the page access policy;
export const hasPagePermission = (page) => {
  const decision = evalutePolicy(page?.accessRules);
  if (decision === ALLOW) {
    return true;
  }
  return false;
};

export const hasJWT = () => {
  const jwt = window.localStorage.getItem("jwt");
  return jwt !== undefined && jwt !== "undefined" && jwt !== null && jwt !== "null";
};
